import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './customDatePickerWidth.css'

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
  paddingBottom: '20px',
}

const aStyle = {
  display: 'none',
}

const options = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
]

const PublicHolidayForm = props => <Formik initialValues={{ user_id: props.publicholiday.publicholiday.user_id, day: props.publicholiday.publicholiday.day, month: props.publicholiday.publicholiday.month, year: props.publicholiday.publicholiday.year, name: props.publicholiday.publicholiday.name, once: props.publicholiday.publicholiday.once, publicdate: '' }} enableReinitialize={true} validate={values => {
      const errors = {}
      const sel = document.getElementById('myonce')
      values.once = sel.childNodes[1].value
      /*const d = document.getElementById('mydate')
      const dval = d.value.split('-')
      values.year = dval[0]
      values.day = dval[2]
      values.month = dval[1]*/
      if (!values.name) {
        errors.name = 'Required'
      } else if (!values.publicdate) {
        errors.publicdate = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      let body = ''
      const datev = new Date(values.publicdate)
      const ddatev = new Date(datev.getTime() - (datev.getTimezoneOffset() * 60000)).toISOString()
      .replace(/T/, ' ')
      .replace(/\..+/, '')
      const dval = ddatev.split('-')
      values.year = dval[0]
      const dtime = dval[2].split(' ')
      values.day = dtime[0]
      values.month = dval[1]
      body = JSON.stringify({id: props.publicholiday.publicholiday.user_id, day: values.day, month: values.month, year: values.year, name: values.name, once: values.once})
      const urlf = '/api/v1/public_holidays/'
      let meth = ''
      meth = 'POST'
      fetch(urlf, {
        method: meth,
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
      .then(response => response.json())
      .then(() => {
        document.getElementById('mylink').click()
      })
      .catch((err) => {
        document.getElementById('mylink').click()
        console.error('Error while adding public holiday! ' + err)
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)
    }}>{({ isSubmitting, errors, values, setFieldValue}) => <Fragment><a href={'/accounting/' + props.publicholiday.publicholiday.user_id} id="mylink" style={aStyle}></a><div className="row col-sm-12 justify-content-top"><h3>Add public holiday</h3></div><br /><Form><div className="row col-sm-12"><div className="col-sm-6" style={divStyle}><div><label htmlFor="date">Date</label><br /><div className="customDatePickerWidth"><DatePicker id="mydate" name="publicdate" dateFormat="dd/MM/yyyy" placeholderText="dd/mm/yyyy" utcOffset={0} selected={values.publicdate !== '' ? new Date(values.publicdate) : values.publicdate} className={'form-control' + (errors.publicdate ? ' is-invalid' : '')} onChange={ (val) => { setFieldValue('publicdate', val, false) }} onSelect={ (val) => setFieldValue('publicdate', val, false) }></DatePicker></div></div><ErrorMessage name="publicdate" component="div"></ErrorMessage><br /><label htmlFor="once">Just this year? Once?</label><br /><Select id="myonce" name="once" options={options} defaultValue={options[0]}></Select><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="name">Name</label><br /><Field type="text" name="name" className={'form-control' + (errors.name ? ' is-invalid' : '')}></Field></div><ErrorMessage name="name" component="div"></ErrorMessage><br /></div><br /><br /><button type="submit" disabled={isSubmitting}>Add public holiday</button><br /><br /></div></Form></Fragment>}</Formik>

PublicHolidayForm.propTypes = {
  publicholiday: PropTypes.object,
}

export default PublicHolidayForm
